import { routeList } from '@/router/helpers/routes'

export default [{
	path: routeList.SUPPORT_BASE_PATH,
	beforeEnter (to, from, next) {
		next(false)
	}
}, {
	path: routeList.SUPPORT_REQUESTS_PATH,
	name: routeList.SUPPORT_REQUESTS_NAME,
	props: true,
	component: () => import('@/views/support/Requests')
}]
